import { useState, useCallback } from "react";
import {
  createImagePreview,
  validateFile,
  resetFileInput,
} from "../utils/fileUtils";
import { useDragAndDrop } from "./useDragAndDrop";

export const useImageUpload = (inputId) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileUpload = useCallback(
    async (event) => {
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Validate file
        const validation = validateFile(file);
        if (!validation.valid) {
          setError(validation.error);
          return;
        }

        // Set image
        setImage(file);

        // Create preview
        const previewUrl = await createImagePreview(file);
        setPreview(previewUrl);
      } catch (err) {
        setError(err.message || "Error processing file");
        setImage(null);
        setPreview(null);
      } finally {
        setLoading(false);
      }
    },
    [inputId]
  );

  const removeImage = useCallback(() => {
    setImage(null);
    setPreview(null);
    setError(null);
    resetFileInput(inputId);
  }, [inputId]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  // Drag and Drop functionality
  const { isDragOver, dragProps } = useDragAndDrop(handleFileUpload);

  return {
    image,
    preview,
    loading,
    error,
    isDragOver,
    handleFileUpload,
    removeImage,
    clearError,
    dragProps,
  };
};
